import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { type ReactNode } from "react";

interface ShiftInfoRowProps {
  readonly label: string;
  readonly value: ReactNode;
}

export function ShiftInfoRow({ label, value }: ShiftInfoRowProps) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {label}
      </Text>
      {typeof value === "string" ? <Text variant="body2">{value}</Text> : value}
    </Stack>
  );
}
